import script from "./json-array.vue?vue&type=script&lang=js"
export * from "./json-array.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/extra/VabJsonViewer/types/json-array.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39c4cb20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39c4cb20', __exports__)) {
    console.log('reload')
    api.reload('39c4cb20', __exports__)
  }
  
}


export default __exports__